<form #validationForm="ngForm" class="editForm" novalidate>
  <div class="auth-wrapper">
    <div class="auth-content">
      <div class="card">
        <div class="row align-items-center text-center">
          <div class="col-md-12">
            <div class="card-body">
              <img src="assets/images/ptsllogo-combined.jpg" alt="" class="img-fluid mb-4">
              <h4 class="mb-3 f-w-400">Login</h4>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="feather icon-tag"></i></span>
                </div>
                <input type="text" class="form-control" name="accountnumber" placeholder="Account Number" [ngClass]="{'is-invalid': !accountnumber.valid && (accountnumber.dirty || accountnumber.touched || isSubmit)}" #accountnumber="ngModel" required [(ngModel)]="formInput.accountnumber">
                <label *ngIf="!accountnumber.valid && (accountnumber.dirty || accountnumber.touched || isSubmit)" id="accountnumber-error" class="error jquery-validation-error small form-text invalid-feedback">Please enter your account number</label>
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="feather icon-mail"></i></span>
                </div>
                <input class="form-control input-md" id="username" name="username" type="text" placeholder="Enter Email" [ngClass]="{'is-invalid': !username.valid && (username.dirty || username.touched || isSubmit)}" #username="ngModel" required username [(ngModel)]="formInput.username">
                <label *ngIf="!username.valid && (username.dirty || username.touched || isSubmit)" id="validation-username-error" class="error jquery-validation-error small form-text invalid-feedback">Please enter a valid username address.</label>
              </div>
              <div class="input-group mb-4">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="feather icon-lock"></i></span>
                </div>
                <input type="password" class="form-control" name="password" placeholder="Enter Password" [ngClass]="{'is-invalid': !password.valid && (password.dirty || password.touched || isSubmit)}" #password="ngModel" minlength="6" required [(ngModel)]="formInput.password">
                <label *ngIf="!password.valid && (password.dirty || password.touched || isSubmit)" id="password-error" class="error jquery-validation-error small form-text invalid-feedback">Please enter a valid password.</label>
              </div>
              <div class="form-group">
                <div
                  class="alert alert-danger"
                  role="alert"
                  *ngIf="isLoginFailed"
                >
                  Login failed : {{error}}
                </div>
              </div>
              <div class="form-group text-left mt-2">
              </div>
              <button type="button" uiSref="work" class="btn btn-primary btn-raised"  (click)="save(validationForm)"> Login <span style="margin-left:10px;"><i class="feather icon-chevron-right"></i></span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>